module.exports = __webpack_public_path__ + "images/fa-cfa-hero-mobile.webp";